const clientFilters = {
  businessEntityId: null,
  name: null,
  active: true,
  invoiceFrequencyId: null,
  thirdPartyPortalId: null
}

export default () => Object.assign({}, clientFilters)
